import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MaterialModule } from '../../material/material.module';
import { CustomDatePickerModule } from '../custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from '../custom-input/custom-input.module';
import { CustomTimpickerModule } from '../custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from '../expansion-panel/expansion-panel.module';
import { FetchBdnFileComponent } from './fetch-bdn-file.component';



@NgModule({
  declarations: [FetchBdnFileComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    MaterialModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatPaginatorModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    ExpansionPanelModule
  ],
  exports: [
    FetchBdnFileComponent



  ]
})
export class FetchBdnFileModule { }
